import React, { useContext, useEffect, useRef, useState } from "react";
import PageName from "../Utils/PageName";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "react-data-table-component-extensions/dist/index.css";
import { environmentVariables } from "../../config/env.config";
import { userContext } from "../../context/userContext";
import { ToastContainer, toast } from "react-toastify";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import { useTranslation } from "react-i18next";

import ReactDOM from "react-dom";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { businessContext } from "../../context/businessContext";
import "./SuperAdminUpdatedStyle.css";
import {
  formatDateTime,
  formatSessionTime,
} from "../Components/DateTimeFormat/DateTimeFormat";
import Swal from "sweetalert2";
import LogoutIcon from "../../Images/turn-off.png";

function Users_Login_List() {
  const baseUrl = environmentVariables?.apiUrl;
  const { userData } = useContext(userContext);
  const { t } = useTranslation();
  console.log("usertoken", userData?.token);
  const [responseData, setResponseData] = useState([]);
  const [formConfigData, setFormConfigData] = useState({
    key: "",
    value: "",
  });
  // console.log(formConfigData, "formConfigDataformConfigData")
  const [isSubmit, setIsSubmit] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  // const { userData, setUserData } = useContext(userContext);

  // console.log(selectedType, "selectedTypeselectedType")
  const [isLoading, setIsLoading] = useState(false);

  async function fetchData() {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${baseUrl}api/v1/user/getAllLoggedInUsersData`,
        {
          headers: {
            _token: userData?.token,
          },
        }
      );
      console.log(response.status, "response.status");
      if (response.status === 200) {
        const responseData = response?.data?.data;
        // console.log(responseData, "@@@@@@@@@@@@@@@@@@@@@@@@@")
        setResponseData(responseData);

        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setResponseData([]);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  const tableExtensions = {
    export: false,
    print: false,
  };

  const handleLogout = async (data) => {
    console.log("Logout confirmed:", data);
    Swal.fire({
      title: "Logout Confirmation",
      text: "Are you sure you want to logout this user?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Logout",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            `${baseUrl}api/v1/user/force-logout`,
            null,
            {
              headers: {
                sessionId: data?.session_id,
              },
            }
          );
          console.log("response", response);
          const { success, message } = response.data;
  
          if (success) {
            fetchData()
            console.log("Logout successful:", message, userData);
            // Clear local storage and user data
            // localStorage.clear();
            // setUserData(null);
          } else {
            console.error(message);
            toast.error(error?.response?.data?.message || error?.message);
            // localStorage.clear();
            // setUserData(null);
          }
        } catch (error) {
          console.error(error);
          toast.error(error?.response?.data?.message || error?.message);
        }
      }
    });
  };
  const columns = [
    {
      name: "Name",
      selector: (row) => (row?.users.name ? row?.users?.name : "--"),
      sortable: true,
      width: "120px",
    },
    {
      name: "Email",
      selector: (row) => (row?.users?.email ? row?.users?.email : "--"),
      sortable: true,
      width: "160px",
    },
    {
      name: "Login Time",
      selector: (row) =>
        row?.login_time ? formatDateTime(row?.login_time) : "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Logout Time",
      selector: (row) =>
        row?.logout_time ? formatDateTime(row?.logout_time) : "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Session Time",
      selector: (row) =>
        row?.session_time ? formatSessionTime(row?.session_time) : "--",
      sortable: true,
    },
    {
      name: "IP Address",
      selector: (row) => row?.ip_address || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Platform",
      selector: (row) => row?.platform || "--",
      sortable: true,
    },
    {
      name: "Device",
      selector: (row) => row?.deviceOs || "--",
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => row?.location || "--",
      sortable: true,
      width: "400px",
    },
    {
      name: "Action",
      sortable: false,
      selector: "null",
      cell: (d) =>
        d?.users?.id === 1 ? (
          "--"
        ) : 
          d?.logout_time ? (
            <>
             Logged Out
            </>
           
          )
          : (
          <>
            <img  key={d.id} src={LogoutIcon} alt="logout"  onClick={() => handleLogout(d)} style={{height:"25px",width:"25px",cursor:"pointer"}}/>
          </>
        
        ),
      
    }
  ];

  const customStyles = {
    headRow: {
      style: {
        width: "100%",
        backgroundColor: "#E9E9E9",
        minHeight: "52px",
        borderRadius: "2px 2px 0px 0px",
        padding: "8px 25px",
        border: "none",
        textAlign: "left",
      },
    },
    headCells: {
      style: {
        color: "#525252",
        fontSize: "16px", // Same font size as regular cells
        minHeight: "52px",
        padding: "8px 10px", // Same padding as regular cells
        textAlign: "left",
      },
    },
    rows: {
      style: {
        padding: "6px 0px 6px 25px", // Ensure similar padding here
        fontSize: "13px", // Match font size with header
        textTransform: "capitalize",
        minHeight: "48px !important",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      },
    },
    cells: {
      style: {
        // minWidth: "50px !important",
        padding: "8px 10px", // Same padding as header cells
        fontSize: "13px", // Match font size with header
        textAlign: "left", // Ensure same text alignment as header
      },
    },
  };

  const tableData = {
    columns,
    data: responseData,
  };
  const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    selectAllRowsItem: true,
    selectAllRowsItemText: t("All"),
  };
  //   console.log("responseData", responseData);
  return (
    <>
      <PageName PageName="Login Logs" />
      <div className="main login-logs">
        {isLoading ? (
          <CircularLoader size={40} />
        ) : (
          <>
            <DataTableExtensions
              {...tableExtensions}
              {...tableData}
              customStyles={customStyles}
              filterPlaceholder="Search User By name"
            >
              <DataTable
                columns={columns}
                data={tableData}
                noHeader
                defaultSortField="id"
                sortIcon={<SortIcon />}
                defaultSortAsc={true}
                pagination
                highlightOnHover
                dense
                paginationComponentOptions={{
                  ...paginationOptions,
                }}
                customStyles={customStyles}
                noDataComponent={
                  <div style={{ padding: "24px" }}>{t("No_records_found")}</div>
                }
              />
            </DataTableExtensions>
          </>
        )}
      </div>
    </>
  );
}

export default Users_Login_List;
